import { createFileRoute, Outlet } from "@tanstack/react-router";

import { SettingsLayout } from "../components/settings/SettingsLayout";

function SettingsRouteView() {
  return (
    <SettingsLayout>
      <Outlet />
    </SettingsLayout>
  );
}

export const Route = createFileRoute("/_app/settings")({
  component: SettingsRouteView,
});
